enum ContainerType {
    Standard = "Standard",
    Ticket = "Ticket", // Ordine o Ordine cliente
}

export default ContainerType;